export default "__VITE_ASSET__5629e857__"